module.exports = __webpack_public_path__ + "images/emoji/turtle.e961f8a59e99d209b82b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/turtle.png
// module id = nuFJ
// module chunks = 14